<template>
  <div class="home">
    <!-- <ul class="filters">
      <li><a v-on:click="showPros" v-bind:class="{'selected': filter==='pros'}">PROs</a></li>
      <li><a v-on:click="showClients" v-bind:class="{'selected': filter==='clients'}">Clients</a></li>
      <li><input v-bind:class="{'selected': filter==='search'}" placeholder="Search" v-model="search" v-on:input="searchChange" /></li>
    </ul> -->
    <div id="companies-table" class="data-table">
      <div class="header">
        <div class="id">Company</div>
        <!-- <div>Verified</div> -->
        <div>PublishedAt</div>
        <div>Diff</div>
      </div>
      <div v-for="audit in audits" v-bind:key="audit.eventId" class="row">
        <div class="cell id">{{audit.objectId}}</div>
        <!-- <div class="cell id">{{isUserVerified(audit.objectId)}}</div> -->
        <div class="cell">{{(new Date(audit.publishedAt._seconds * 1000).toLocaleString())}}</div>
        <div class="cell">{{getDiff(audit)}}</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
#companies-table{
  grid-template-columns: auto auto auto;
}
</style>


<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import api from '../services/api';
import _ from 'lodash';

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
function difference(object, base) {
	function changes(object, base) {
		return _.transform(object, function(result, value, key) {
			if (!_.isEqual(value, base[key])) {
				result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
			}
		});
	}
	return changes(object, base);
}

export default {
  name: 'home',
  created: async function() {
    this.audits = await api.getAudit('companies');
  },
  data: function() {
    return {
      audits: [],
      filter: 'taskers',
      search: ''
    }
  },
  methods: {
    // getUserName(id) {
    //   const users = this.$store.state.users;
    //   const user = users[id];
    //   if (user) {
    //     return user.firstName + ' ' + user.lastName;
    //   } else {
    //     return id;
    //   }
    // },
    // isUserVerified(id) {
    //   const users = this.$store.state.users;
    //   const user = users[id];
    //   if (user) {
    //     return user.verified;
    //   } else {
    //     return id;
    //   }
    // },
    getDiff(event) {
      if (event.data) {
        // delete event.data.updatedAt;
        // delete event.data.updatedBy;
        // delete event.data.fcmToken;
      }
      if (event.prevData) {
        // delete event.prevData.updatedAt;
        // delete event.prevData.updatedBy;
        // delete event.prevData.fcmToken;
        // delete event.prevData.updatedAt;
      }
      const diff = difference(event.data || {}, event.prevData || {});
      if (diff.fcmToken) {
        diff.fcmToken = '-';
      }
      if (diff.updatedBy) {
        diff.updatedBy = '-';
      }
      delete diff.updatedAt;
      return diff;
    }
  }
  // components: {
  //   HelloWorld
  // }
}
</script>
